import styled from 'styled-components'

export const SubtabWrapper = styled.div`
  display: inline-block;
  margin-top: 1rem;
`

export const Subtab = styled.div<{ active: boolean }>`
  display: inline-block;
  padding: 6px 12px;
  border-bottom: ${({ active }) => (active ? '2px solid #2563eb' : '2px solid transparent')};
  cursor: pointer;
  color: ${({ active }) => (active ? '#2563eb' : '#444')};
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  margin-right: 16px;
`
